import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { UserService } from 'src/app/services/User.service';

@Component({
  selector: 'app-bid-confirmation',
  templateUrl: './bid-confirmation.component.html',
  styleUrls: ['./bid-confirmation.component.scss']
})
export class BidConfirmationComponent implements OnInit, OnChanges, OnDestroy {

  @Input() visible: boolean = false;
  @Input() vendorName: string = '';
  @Input() vendorId: any = '';
  @Input() bidMonthLabel: string = '';
  @Input() submittedBids: any[] = [];
  /** data:application/pdf;base64,.... string returned by DisplayBidEntryReceipt */
  @Input() receiptPdfBase64: string = '';
  @Output() closeModal = new EventEmitter<void>();

  @ViewChild('printReceiptPopup') printReceiptPopup!: ModalDirective;
  @ViewChild('printf') printf!: ElementRef<HTMLIFrameElement>;

  marketName: string = '';
  marketLogoUrl: string = '../assets/images/NoImage.jpg';
  receiptUnavailable: boolean = false;
  receiptSafeUrl: SafeResourceUrl | null = null;

  private marketId: any;
  private subscriptions: Subscription[] = [];
  private receiptBlobUrl: string | null = null;

  constructor(
    private userService: UserService,
    private marketInfoService: MarketInfoService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.marketId = this.userService.getMarketId();
    this.loadMarketLogo();
    this.loadMarketName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['receiptPdfBase64']) {
      this.setReceiptBlobUrl(this.receiptPdfBase64);
    }
  }

  private loadMarketLogo(): void {
    const ts = new Date().getTime();
    this.subscriptions.push(
      this.marketInfoService.getMarketLogo(this.marketId).subscribe((res: any) => {
        this.marketLogoUrl = res?.MarketLogoBlobURL
          ? `${res.MarketLogoBlobURL}?timestamp=${ts}`
          : '../assets/images/NoImage.jpg';
      })
    );
  }

  private loadMarketName(): void {
    this.subscriptions.push(
      this.marketInfoService.getMarketDetails(this.marketId).subscribe((res: any) => {
        if (res) { this.marketName = res.MarketName; }
      })
    );
  }

  private setReceiptBlobUrl(dataUri: string): void {
    this.revokeReceiptBlobUrl();
    this.receiptUnavailable = false;
    this.receiptSafeUrl = null;

    if (!dataUri) {
      this.receiptUnavailable = true;
      return;
    }

    try {
      const base64 = dataUri.substring(dataUri.indexOf(',') + 1);
      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
      this.receiptBlobUrl = URL.createObjectURL(blob);
      this.receiptSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.receiptBlobUrl);
    } catch {
      this.receiptUnavailable = true;
      this.receiptBlobUrl = null;
    }
  }

  private revokeReceiptBlobUrl(): void {
    if (this.receiptBlobUrl) {
      URL.revokeObjectURL(this.receiptBlobUrl);
      this.receiptBlobUrl = null;
    }
    this.receiptSafeUrl = null;
  }

  onOpenReceipt(): void {
    if (!this.receiptBlobUrl) { return; }
    this.printReceiptPopup.show();
  }

  onPrint(): void {
    if (!this.receiptBlobUrl) { return; }
    const win = this.printf?.nativeElement?.contentWindow;
    if (!win) { return; }
    win.focus();
    win.print();
  }

  onClose(): void {
    this.closeModal.emit();
  }

  onHome(): void {
    this.closeModal.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.revokeReceiptBlobUrl();
  }
}
